import { GeoJSON as GeoJSONMarkup } from "react-leaflet";
import useGeoJsonShapeFiles from "@/services/store/useGeoJsonShapeFiles";

const GeoJsonFiles = () => {
  const geoJsonObjects = useGeoJsonShapeFiles((state) => state.geoJsonObjects);
  return (
    <>
      {Object.keys(geoJsonObjects).map((file: string) => (
        <GeoJSONMarkup data={geoJsonObjects[file]} style={{ color: "#000000" }} key={file} />
      ))}
    </>
  );
};

export default GeoJsonFiles;
